import { push, replace } from 'connected-react-router';
import { stringifyUrl } from 'query-string';
import { Dispatch } from 'redux';
import { StandardQueryParams } from '../../global/types';
import { VENDORS_URL } from '../../global/urls';
import { defaultSortOrder } from './constants';

type QueryParams = StandardQueryParams & { type?: string };

export const getVendorsUrl = (params: QueryParams): string => {
  const query: QueryParams = {};
  if (params.search) {
    query.search = params.search;
  }
  if (params.sort && params.sort !== defaultSortOrder) {
    query.sort = params.sort;
  }
  if (params.start) {
    query.start = params.start;
  }
  if (params.type) {
    query.type = params.type;
  }
  return stringifyUrl({ url: VENDORS_URL, query });
};

export const replaceVendorsUrl = (dispatch: Dispatch, params: QueryParams): void => {
  const url = getVendorsUrl(params);
  dispatch(replace(url, { keepState: true }));
};

export const pushVendorsUrl = (
  dispatch: Dispatch,
  params: QueryParams,
  keepState = false
): void => {
  const url = getVendorsUrl(params);
  dispatch(push(url, { keepState }));
};
